import { TimePeriod } from '@services/FiltersTypes';
import { getSessionStorage, StorageKey } from '@utils/StorageUtils';
import { MultiCountryLatestTimeFrameTypes } from '@state/actions/Type';

export interface MultiCountryLatestTimeFrameState {
  latestTimePeriod: TimePeriod;
}

const getInitialState = () => {
  const storeMultiCountryLatestTimeFrame = JSON.parse(
    getSessionStorage(StorageKey.MultiCountryLatestTimeFrame) as string,
  );

  if (storeMultiCountryLatestTimeFrame !== null) {
    return {
      latestTimePeriod: storeMultiCountryLatestTimeFrame.latestTimePeriod,
    };
  }

  return Object.freeze({ latestTimePeriod: {} as TimePeriod });
};

const MultiCountryLatestTimeFrameReducer = (
  state: MultiCountryLatestTimeFrameState = getInitialState(),
  action: any,
) => {
  if (action.type === MultiCountryLatestTimeFrameTypes.MultiCountryLatestTimeFrameUpdate) {
    return {
      ...state,
      latestTimePeriod: action.payload.latestTimePeriod,
    };
  }

  return state;
};

export default MultiCountryLatestTimeFrameReducer;
